import nl from './nl.json';
import fr from './fr.json';

export default { nl, fr };
